import { forwardRef } from 'react';
import cn from 'classnames';
import { motion } from 'framer-motion';

import { SplitTitle } from '@/components/ui/SplitTitle/SplitTitle';

import { useCurrentLotteryTier } from '../../hooks';

interface TitleProps {
  className?: string;
}

const Title = forwardRef<HTMLDivElement, TitleProps>(({ className }, ref) => {
  const currentTicketType = useCurrentLotteryTier();

  return (
    <motion.div ref={ref} className={cn('w-full flex items-end', className)}>
      <SplitTitle className="capitalize" text={currentTicketType} />
    </motion.div>
  );
});

export { Title };
